import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-lista-usuarios',
  templateUrl: './lista-usuarios.component.html',
  styleUrls: ['./lista-usuarios.component.css'],
})
export class ListaUsuariosComponent implements OnInit {
  @Input() usuarios!: any;
  @Input() usuariosVinculadosAoAgrupamento = [] as any;
  @Output() enviaUsuarios = new EventEmitter();
  public paginaAtual = 1;
  filtrar = '';
  usuariosTabela = [] as any;
  usuariosSelecionado = [] as any;
  constructor(private router: Router) {}

  ngOnInit(): void {
    this.usuariosTabela = this.usuarios;
    this.usuariosSelecionado = this.usuariosVinculadosAoAgrupamento;
  }

  filtrarUsuario() {
    this.paginaAtual = 1;
    this.usuariosTabela = this.usuarios.filter((item: any) =>
      item.vc_nome.toLowerCase().includes(this.filtrar.toLowerCase())
    );
  }

  selecionarusuario(usuario: any) {
    let existe = this.usuariosSelecionado.some((item: any) => {
      return item.sr_id == usuario.sr_id;
    });
    if (!existe) {
      this.usuariosSelecionado.push(usuario);
    }
  }

  removerUsuario(index: any) {
    this.usuariosSelecionado.splice(index, 1);
  }

  enviarUsuariosSelecionados() {
    this.enviaUsuarios.emit(this.usuariosSelecionado);
  }

  ngOnChanges() {
    this.usuariosTabela = this.usuarios;
  }

  cancel() {
    this.router.navigate(['configuracao/agrupamentos']);
  }
}
